export const MAX_DOLLAR_AMOUNT = 10_000_000_000;
export const MAX_GENERIC_NUMBER = 10_000;
export const MAX_SALARY_MULTIPLIER = 100;
export const MAX_DECIMAL_NUMBER = 1_000_000;
